<template>
  <div>

    <v-card flat class="ma-md-8 mt-md-2 rounded-lg">

      <v-skeleton-loader type="list-item@8" v-if="loading"></v-skeleton-loader>

      <div v-if="items.length === 0 && !loading" class="pa-4">
        Er zijn geen mappen en formulieren gevonden voor deze klant.
      </div>

      <v-treeview
          v-model="tree"
          :open="initiallyOpen"
          :items="items"
          item-key="folder_id"
          open-on-click
          dense
          v-if="items"
      >
        <template v-slot:prepend="{ item, open }">
          <v-icon v-if="item.folder_name">
            {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
          </v-icon>
          <v-icon v-else>
            mdi-text-box-outline
          </v-icon>
        </template>
        <template v-slot:label="{item}">
          <v-sheet @click="itemClick(item)">
            {{ item.folder_name }} {{ item.form_name }}

            <form-description-tooltip :form="item"></form-description-tooltip>

          </v-sheet>
        </template>
      </v-treeview>

    </v-card>

    <pwa-install-prompt></pwa-install-prompt>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import PwaInstallPrompt from "@/components/PwaInstallPrompt";
import axios from "axios";
import FormDescriptionTooltip from "@/components/FormDescriptionTooltip.vue";

export default {
  components: {
    FormDescriptionTooltip,
    PwaInstallPrompt,
  },
  data () {
    return {
      loading: true,
      tree: [],
      initiallyOpen: ['public'],
      items: [],
    }
  },
  mounted () {
    // Get registration from API
    if (this.appOnline) {
      this.getDataFromApi();
    }
  },
  computed: {
    ...mapGetters(["appOnline"]),
  },
  methods: {
    async getDataFromApi() {
      this.loading = true;

      try {
        let client_id = this.$store.getters.CurrentClient;
        let response = await axios.get('/api/client/'+client_id+'/folder/user');
        this.items = response.data;

      } catch (error) {
        console.log(error);
      }
      finally {
        this.loading = false;
      }
    },
    itemClick(item) {
      // Open form if it's a form
      if (item.form_id) {
        this.$router.push({ name: 'form_fill', params: {form_id: item.form_id, force_reload: '0'} })
      }
    },
  },
}
</script>

<style scoped>

</style>